import { memo, useCallback } from "react"
import { GridRowParams } from "@mui/x-data-grid-pro"

import {
    IContractTableItem,
    IContractListViewProps,
} from "src/views/contracts/pages/list/types/contract-list"
import { DataGridProTable } from "src/components/Table/DataGridPro"
import { Repository } from "src/types/channel"

export const ContractListTable = memo(
    ({
        loading,
        data,
        columns,
        repository,
        onRowClick,
        paginator,
    }: IContractListViewProps) => {
        const handleRowClick = useCallback(
            (params: GridRowParams<IContractTableItem>) => {
                onRowClick(params.row)
            },
            [onRowClick],
        )

        return (
            <DataGridProTable
                paginator={paginator}
                data={data}
                columns={columns}
                advancedOperations={{
                    pagination: "server",
                }}
                onRowClickEvent={handleRowClick}
                repository={repository as Repository}
                loading={loading}
                hideToolbar
                sx={{
                    overflowX: "scroll",
                    backgroundColor: "background.paper",
                    breakInside: "avoid",
                }}
            />
        )
    },
)
